const axios = require('axios');
const FormData = require('form-data');
const COOKIES_VTKT = 'VTKT'

// init API を実行
export function postInitApi() {
  return new Promise(function (resolve, reject) {
    const apiPath = "/init"
    const headers = {
      'accept': 'application/json',
      'Content-Type': 'application/json',
    }
    const vtkt = getVtktCookie()
    const url = `${process.env.VUE_APP_BASE_API_URL}${apiPath}`
    const data = {vtkt: vtkt}
    axios.post(url, data, headers)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// claim/insert/check API を実行
export function postClaimInsertCheckApi(data) {
  return new Promise(function (resolve, reject) {
    const apiPath = "/claim/insert/check"
    const url = `${process.env.VUE_APP_BASE_API_URL}${apiPath}`
    const headers = {
      'accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    }
    let body = {...data.body, vtkt: getVtktCookie()}
    let formData = new FormData();
    formData.append('body', JSON.stringify(body));

    let images = data.images
    for (let key in images) {
      formData.append(key, images[key]);
    }
    axios.post(url, formData, headers)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// claim/insert/ API を実行
export function postClaimInsertApi(data) {
  return new Promise(function (resolve, reject) {
    const apiPath = "/claim/insert/"
    const url = `${process.env.VUE_APP_BASE_API_URL}${apiPath}`
    const headers = {
      'accept': 'application/json',
      'Content-Type': 'multipart/form-data'
    }
    let body = {...data.body, vtkt: getVtktCookie()}
    let formData = new FormData();
    formData.append('body', JSON.stringify(body));

    let images = data.images
    for (let key in images) {
      formData.append(key, images[key]);
    }
    axios.post(url, formData, headers)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}



// // リクエストパラメータのValueをStringにキャスト
// function dataValueToString(data) {
//   for (let key in data) {
//     if (data[key]) {
//       data[key] = data[key].toString()
//     }
//   }
//   return data
// }


// $cookiesからuser_sessionを取得
function getVtktCookie() {
  if (window.$cookies.isKey(COOKIES_VTKT)) {
    // return "VTKT=zA8qscUxjFMzhBjquA3W0aSUAVJgTu0HBKxYJuyXk6OWVnqEk5j__7B0xiwNbW66lJ0Vjfk04RuTanBXabDuGDr8C-7LtyPYnyzVdvPq1krI8rUtyJ7foJVuSO2H0TPrdtH7g5bCK4BlpyB_B-9aCA"
    return window.$cookies.get(COOKIES_VTKT)
  }
  return ""
}
